module.exports = __webpack_public_path__ + "img/gb119-86-d3.prt.ebade666.jpg";